/* ==========================================================================
   hc-collection-highlight — Carousel Controller
   Custom Element + Embla Carousel (mobile only)
   Desktop: CSS grid (Embla destroyed)
   Mobile:  Embla horizontal carousel + pill dot indicator
   ========================================================================== */

if (!customElements.get('hc-ch-carousel')) {
  class HcChCarousel extends HTMLElement {
    constructor() {
      super();
      this.embla = null;
      this.dotNodes = [];
      this.mql = window.matchMedia('(max-width: 749px)');
      this.handleViewport = this.handleViewport.bind(this);
    }

    connectedCallback() {
      this.mql.addEventListener('change', this.handleViewport);
      this.handleViewport();
    }

    disconnectedCallback() {
      this.mql.removeEventListener('change', this.handleViewport);
      this.destroyEmbla();
    }

    /** Init or destroy Embla based on viewport width */
    handleViewport() {
      if (this.mql.matches) {
        this.initEmbla();
      } else {
        this.destroyEmbla();
      }
    }

    /** Activate Embla carousel for mobile */
    initEmbla() {
      if (this.embla) return;
      var viewport = this.querySelector('[data-js="viewport"]');
      var indicator = this.querySelector('[data-js="indicator"]');
      if (!viewport || typeof EmblaCarousel === 'undefined') return;

      this.embla = EmblaCarousel(viewport, {
        align: 'start',
        containScroll: 'trimSnaps',
        dragFree: true,
        loop: false
      });

      if (indicator) {
        this.buildDots(indicator);
        this.embla.on('select', () => this.updateDots());
        this.embla.on('reinit', () => {
          this.buildDots(indicator);
          this.updateDots();
        });
      }
    }

    /** Clean up Embla + dots for desktop */
    destroyEmbla() {
      if (this.embla) {
        this.embla.destroy();
        this.embla = null;
      }
      var indicator = this.querySelector('[data-js="indicator"]');
      if (indicator) indicator.innerHTML = '';
      this.dotNodes = [];
    }

    /** Build dot indicators from Embla snap list */
    buildDots(container) {
      var snaps = this.embla.scrollSnapList();
      container.innerHTML = '';
      this.dotNodes = [];

      snaps.forEach((_, i) => {
        var dot = document.createElement('button');
        dot.className = 'hc-collection-highlight__indicator-dot';
        dot.setAttribute('aria-label', 'Go to product group ' + (i + 1));
        dot.addEventListener('click', () => this.embla.scrollTo(i));
        container.appendChild(dot);
        this.dotNodes.push(dot);
      });

      this.updateDots();
    }

    /** Toggle active dot */
    updateDots() {
      if (!this.embla || !this.dotNodes.length) return;
      var selected = this.embla.selectedScrollSnap();
      this.dotNodes.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === selected);
      });
    }
  }

  customElements.define('hc-ch-carousel', HcChCarousel);
}
